import { Http } from 'services/http'

async function subscribe(email, postalCode) {
  const options = {
    email,
    mailing_list: 'new_postal_code',
    params: { postal_code: postalCode },
  }

  return Http.post('/newsletters/', {
    body: JSON.stringify(options),
  })
}

export const NotifyMeClient = {
  subscribe,
}
